var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-row',{staticClass:"content-title text-center"},[_c('h2',{staticClass:"gray-text"},[_vm._v("Выберите раздел")])])
}
var staticRenderFns = []

export { render, staticRenderFns }